import * as Yup from "yup"
import { formTranslation } from "../../../../locales/form"

export const DialogMessageInputEmailSchema = Yup.object().shape({
    email: Yup.object().shape({
        to: Yup.string()
            .requiredExcludeEmpty(formTranslation.emailRequired)
            .test({
                name: "isSingleEmail",
                message: formTranslation.moreThanOneEmail,
                test: function (value) {
                    if (!value) {
                        return true
                    }

                    const hasSeparators = /[,; ]/.test(value)

                    return !hasSeparators
                }
            })
            .email(formTranslation.emailInvalid),
        cc: Yup.array().of(Yup.string().email(formTranslation.emailInvalid)),
        bcc: Yup.array().of(Yup.string().email(formTranslation.emailInvalid))
    })
})
